import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

import { renderInstructorPage } from './-route-wrappers';

const StudentOnDemandTutoring = lazyRouteComponent(() => import('@/_instructor/customer-profile/on-demand-tutoring'));

export const Route = createFileRoute('/_instructor/student/on-demand-tutoring')({
  component: () => renderInstructorPage(StudentOnDemandTutoring),
});
